import executeApi from 'shared/executeApi';
import { fetchAuthSession } from 'aws-amplify/auth';

// メインパラメータの構造体格納
const packingMain = (
  param: any,
) => {
  var ret = {
    "mainCategory":param["mainCategory"],
    "subCategory":param["subCategory"],
    "item":param["item"],
    "scaleCode":param["scaleCode"],
    "edition":param["edition"],
    "fiscalYM1": {},
    "fiscalYM2": {},
    "fiscalYM3": {},
  };

  return ret;
};

// 貸借対照表の構造体格納
const packingBS = (
  param: any,
) => {
  var ret = {
    "TCA":param["TCA"],
    "TCA_CA":param["TCA_CA"],
    "TCA_CA_CaD":param["TCA_CA_CaD"],
    "TCA_CA_AR":param["TCA_CA_AR"],
    "TCA_CA_ARaCWUP":param["TCA_CA_ARaCWUP"],
    "TCA_CA_S":param["TCA_CA_S"],
    "TCA_I":param["TCA_I"],
    "TCA_I_S":param["TCA_I_S"],
    "TCA_I_WIP":param["TCA_I_WIP"],
    "TCA_I_RMS":param["TCA_I_RMS"],
    "TCA_I_CIPE":param["TCA_I_CIPE"],
    "TCA_OCA":param["TCA_OCA"],
    "TCA_OCA_AP":param["TCA_OCA_AP"],
    "TCA_OCA_PEAI":param["TCA_OCA_PEAI"],
    "TCA_OCA_O":param["TCA_OCA_O"],
    "TCA_AfDA":param["TCA_AfDA"],
    "TFA":param["TFA"],
    "TFA_TFA":param["TFA_TFA"],
    "TFA_TFA_BaS":param["TFA_TFA_BaS"],
    "TFA_TFA_ME":param["TFA_TFA_ME"],
    "TFA_TFA_VTE":param["TFA_TFA_VTE"],
    "TFA_TFA_TES":param["TFA_TFA_TES"],
    "TFA_TFA_L":param["TFA_TFA_L"],
    "TFA_TFA_CiP":param["TFA_TFA_CiP"],
    "TFA_IFA":param["TFA_IFA"],
    "TFA_IaOA":param["TFA_IaOA"],
    "TFA_IaOA_IS":param["TFA_IaOA_IS"],
    "TFA_IaOA_O":param["TFA_IaOA_O"],
    "TDA":param["TDA"],
    "TA":param["TA"],
    "TL":param["TL"],
    "TL_TCL":param["TL_TCL"],
    "TL_TCL_BP":param["TL_TCL_BP"],
    "TL_TCL_APUC":param["TL_TCL_APUC"],
    "TL_TCL_STB":param["TL_TCL_STB"],
    "TL_TCL_APaUCP":param["TL_TCL_APaUCP"],
    "TL_TCL_AEaUR":param["TL_TCL_AEaUR"],
    "TL_TCL_BR":param["TL_TCL_BR"],
    "TL_TCL_UCT":param["TL_TCL_UCT"],
    "TL_TCL_OCL":param["TL_TCL_OCL"],
    "TL_TFL":param["TL_TFL"],
    "TL_TFL_CB":param["TL_TFL_CB"],
    "TL_TFL_LTD":param["TL_TFL_LTD"],
    "TL_TFL_ARB":param["TL_TFL_ARB"],
    "TL_TFL_OFL":param["TL_TFL_OFL"],
    "TNA":param["TNA"],
    "TNA_SE":param["TNA_SE"],
    "TNA_SE_C":param["TNA_SE_C"],
    "TNA_SE_CS":param["TNA_SE_CS"],
    "TNA_SE_RE":param["TNA_SE_RE"],
    "TNA_SE_TS":param["TNA_SE_TS"],
    "TNA_VaCD":param["TNA_VaCD"],
    "TNA_VaCD_UGoOS":param["TNA_VaCD_UGoOS"],
    "TNA_VaCD_DGaLoH":param["TNA_VaCD_DGaLoH"],
    "TNA_VaCD_LRD":param["TNA_VaCD_LRD"],
    "TNA_SAR":param["TNA_SAR"],
    "TLaNA":param["TLaNA"],
    "DA":param["DA"],
    "ETB":param["ETB"],
    "DeA":param["DeA"],
    "NoE":param["NoE"],
  };
  return ret;
};

// 損益計算書をパッケージング
const packingPL = (
  param: any,
) => {
  var ret = {
    "S":param["S"],
    "CoS":param["CoS"],
    "GP":param["GP"],
    "SGaAE":param["SGaAE"],
    "OP":param["OP"],
    "TnOI":param["TnOI"],
    "TnOI_IaDA":param["TnOI_IaDA"],
    "TnOI_OnOI":param["TnOI_OnOI"],
    "TnOE":param["TnOE"],
    "TnOE_IaDA":param["TnOE_IaDA"],
    "TnOE_OnOI":param["TnOE_OnOI"],
    "OrP":param["OrP"],
    "SP":param["SP"],
    "EL":param["EL"],
    "PP":param["PP"],
    "APfCT":param["APfCT"],
    "NI":param["NI"],
  };
  return ret;
};

// 決算年月の構造体格納
const packingFiscalYM = (
  param: any,
) => {
  // 貸借対照表をパッケージング
  const bs = param["BS"];
  const bsPack = packingBS(bs);
  // 損益計算書をパッケージング
  const pl = param["PL"];
  const plPack = packingPL(pl);
  var ret = {
    "fiscalYear":param["fiscalYear"],
    "fiscalMonth":param["fiscalMonth"],
    "isComparisonTarget":param["isComparisonTarget"],
    "BS":bsPack,
    "PL":plPack,
  };
  return ret;
};


/** 財務分析計算 */
const calcFinancialAnalysis = async (
  param: any,
) => {

  // 入力値チェック
  let mainParam = packingMain(param);

  // 決算年月別の格納
  for (let i = 1; i < 4; i++) {
    var index = String(i);
    const fiscalYM = param["fiscalYM" + index];
    if(fiscalYM){
      const fiscalYMPack = packingFiscalYM(fiscalYM);
      if(index === "1"){
        mainParam["fiscalYM1"] = fiscalYMPack;
      } else if(index === "2"){
        mainParam["fiscalYM2"] = fiscalYMPack;
      } else if(index === "3"){
        mainParam["fiscalYM3"] = fiscalYMPack;
      }
    }
  }
  
  // 認証情報取得
  const session = await fetchAuthSession();
  const jwtToken = session.tokens?.idToken?.toString();
  // SmeFrontAPIのURLを取得
  const baseURL = process.env.REACT_APP_SME_FRONT_API_ROOT!;
  // 財務分析計算API PATH
  const path = "/financialanalysis/calc/execution";

  try {
    const response = await executeApi(baseURL, path, jwtToken, 0, mainParam);
    if (!response || (response && response.data.res_cd != "I0000")) {
      return {
        res_cd: "E0001",
        msg_title: "Invalid request body",
        msg: "システムエラー",
        financialRatios1:{},
        financialRatios2:{},
        financialRatios3:{},
        standardFinancialRatios:{},
        contrastRatio:{}
      }
    }
    return {
      res_cd: response.data.res_cd,
      msg_title: response.data.msg_title,
      msg: response.data.msg,
      financialRatios1: response.data.financialRatios1,
      financialRatios2: response.data.financialRatios2,
      financialRatios3: response.data.financialRatios3,
      standardFinancialRatios: response.data.standardFinancialRatios,
      contrastRatio: response.data.contrastRatio,
    }
  } catch (e) {
    return {
      res_cd: "E0001",
      msg_title: "Invalid request body",
      msg: "システムエラー",
      financialRatios1:{},
      financialRatios2:{},
      financialRatios3:{},
      standardFinancialRatios:{},
      contrastRatio:{}
    }
  }
};

export default calcFinancialAnalysis;

